import { ResponsivePie } from "@nivo/pie";

const ICUOccupancyGauge = ({ value }) => {
  const data = [
    {
      id: "occupied",
      value: value,
      color: value > 80 ? "#EF4444" : value > 60 ? "#F59E0B" : "#3B82F6",
    },
    {
      id: "remaining",
      value: 100 - value,
      color: "#E5E7EB",
    },
  ];

  return (
    <div className="bg-white p-5 flex items-center justify-between flex-col rounded-xl border border-slate-200 shadow-sm">
      <h3 className="text-md self-start font-semibold mb-0 pt-2">ICU Occupancy</h3>

      <div className="h-52 w-full max-w-[260px] mx-auto">
        <ResponsivePie
          data={data}
          innerRadius={0.75}
          startAngle={-90}
          endAngle={90}
          padAngle={0}
          cornerRadius={6}
          activeOuterRadiusOffset={6}
          colors={{ datum: "data.color" }}
          borderWidth={0}
          enableArcLabels={false}
          enableArcLinkLabels={false}
          tooltip={({ datum }) =>
            datum.id === "occupied" ? (
              <div className="bg-black text-white px-3 py-1 rounded text-sm">
                {value}% Occupied
              </div>
            ) : null
          }
          layers={[
            "arcs",
            ({ centerX, centerY }) => (
              <text
                x={centerX}
                y={centerY}
                textAnchor="middle"
                dominantBaseline="central"
                style={{
                  fontSize: 22,
                  fontWeight: 700,
                  fill: "#0f172a",
                }}
              >
                {value}%
              </text>
            ),
          ]}
        />
      </div>
    </div>
  );
};

export default ICUOccupancyGauge;